import { RouterSettings } from "app/tools/router/types";
import { useFinanceRoutes } from "Finance/routes";
import { UserRoutes, useUserRoutes } from "User/routes";

export const DEFAULT_ROUTE = "/finance";

export const useRouterSettings = (): RouterSettings => {
  const financeRoutes = useFinanceRoutes();
  const userRoutes = useUserRoutes(DEFAULT_ROUTE);

  return {
    defaultRoute: DEFAULT_ROUTE,
    routeLogin: UserRoutes.USER_LOGIN,
    routes: {
      authenticatedOnly: [
        ...(financeRoutes.authenticatedOnly ?? []),
        ...(userRoutes.authenticatedOnly ?? []),
      ],
      public: [...(financeRoutes.public ?? []), ...(userRoutes.public ?? [])],
    },
  };
};
